const images = [
  {
    src: require("../images/aqua-long.png"),
    title: "Image 1",
  },
  {
    src: require("../images/bizcurve.png"),
    title: "Image 1",
  },
  {
    src: require("../images/buzz-traffic.png"),
    title: "Image 1",
  },
  {
    src: require("../images/ch-virbac.png"),
    title: "Image 1",
  },
  {
    src: require("../images/clair.png"),
    title: "Image 1",
  },
  {
    src: require("../images/cyclavance.png"),
    title: "Image 1",
  },
  {
    src: require("../images/cusine.png"),
    title: "Image 1",
  },
  {
    src: require("../images/ch-virbac-photos.png"),
    title: "Image 1",
  },
  {
    src: require("../images/defco.png"),
    title: "Image 1",
  },
  {
    src: require("../images/clair2.png"),
    title: "Image 1",
  },
  {
    src: require("../images/effix.png"),
    title: "Image 1",
  },
  {
    src: require("../images/food-picky.png"),
    title: "Image 1",
  },
  {
    src: require("../images/facipil.png"),
    title: "Image 1",
  },
  {
    src: require("../images/gorkhe.png"),
    title: "Image 1",
  },
  {
    src: require("../images/grease-book.png"),
    title: "Image 1",
  },
  {
    src: require("../images/glass-fox-media.png"),
    title: "Image 1",
  },
  {
    src: require("../images/gtf.png"),
    title: "Image 1",
  },
  {
    src: require("../images/gymbird.png"),
    title: "Image 1",
  },
  {
    src: require("../images/jargo.png"),
    title: "Image 1",
  },
  {
    src: require("../images/housenah-gunny.png"),
    title: "Image 1",
  },
  {
    src: require("../images/kathapps.png"),
    title: "Image 1",
  },
  {
    src: require("../images/kelli-law.png"),
    title: "Image 1",
  },
  {
    src: require("../images/madang.png"),
    title: "Image 1",
  },
  {
    src: require("../images/ppi.png"),
    title: "Image 1",
  },
  {
    src: require("../images/restaurant.png"),
    title: "Image 1",
  },
  {
    src: require("../images/skunk.png"),
    title: "Image 1",
  },
  {
    src: require("../images/plumber-plus.png"),
    title: "Image 1",
  },
  {
    src: require("../images/system-check.png"),
    title: "Image 1",
  },
  {
    src: require("../images/zegg-cerlatti.png"),
    title: "Image 1",
  },
  {
    src: require("../images/yatra.png"),
    title: "Image 1",
  },
];

export default images;
